const PIXEL_ID = '1722954068971040'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: Fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue?.push(args)
    }
  } as Fbq

  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  window.fbq = n
  window._fbq = n

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(script, first)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackCheckoutClick(): void {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Sistema de Decision Clinica para Diabetes',
    value: 14,
    currency: 'USD',
  })
}
